import { Spacing } from '@persona-id/design-tokens';
import { FC } from 'react';
import styled from 'styled-components';

import ConfirmationModal from 'dashboard/components-lib/ConfirmationModal';
import { Environment } from 'dashboard/models/environment';
import { Paragraph } from 'design-system/components/Text';

interface WorkflowActivateModalProps {
  workflowName?: string;
  activeEnvironments: Environment[];
  handleClose: () => void;
  handleConfirm: () => void;
}

const UnorderedList = styled('ul')`
  margin-left: ${Spacing[2]};
  color: ${({ theme }) => theme.color.text.secondary};
`;

const ListItem = styled('li')`
  margin: ${Spacing[1]} 0;
`;

const WorkflowActivateModal: FC<WorkflowActivateModalProps> = ({
  workflowName = 'Workflow',
  activeEnvironments,
  handleClose,
  handleConfirm,
}) => {
  return (
    <ConfirmationModal
      cancelAction={handleClose}
      confirmAction={handleConfirm}
      header='Activate this workflow?'
      confirmActionText='Activate'
      confirmButtonType='primary'
    >
      <Paragraph>
        <strong>{workflowName}</strong> will be activated.{' '}
        <strong>This affects all previously activated environments and includes:</strong>
        <UnorderedList>
          {activeEnvironments.map((env) => (
            <ListItem key={env.id}>{env.attributes.name}</ListItem>
          ))}
        </UnorderedList>
        To activate Workflows in individual environments, click into the Workflow and leverage the
        configuration or publish modals.
      </Paragraph>
    </ConfirmationModal>
  );
};

export default WorkflowActivateModal;
